import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";
import {queryGqlApi} from "../../graphql/queryGqlApi";
import {createLocation, updateLocation, deleteLocation} from "../../graphql/reliability/mutations";

import {Location, CreateLocationInput, UpdateLocationInput} from "./types";

const ENDPOINT = "pgServer";

type Deps = {dataClientService: IDataClientService; authService: IAuthService};

/**
 * All GQL mutations for Locations. Instantiated by action functions.
 * LocationDS auto-syncs via subscriptions after any mutation.
 */
export class LocationGqlProvider {
    private readonly dataClientService: IDataClientService;
    private readonly authService: IAuthService;
    private readonly wsId: string;

    constructor(deps: Deps, wsId: string) {
        this.dataClientService = deps.dataClientService;
        this.authService = deps.authService;
        this.wsId = wsId;
    }

    create(input: Omit<CreateLocationInput, 'workspaceId'>): Promise<Location> {
        return queryGqlApi(
            createLocation, {input: {...input, workspaceId: this.wsId}},
            this.dataClientService, this.authService, ENDPOINT,
        ) as Promise<Location>;
    }

    update(input: UpdateLocationInput): Promise<Location> {
        return queryGqlApi(
            updateLocation, {input},
            this.dataClientService, this.authService, ENDPOINT,
        ) as Promise<Location>;
    }

    async delete(id: string): Promise<void> {
        await queryGqlApi(
            deleteLocation, {id},
            this.dataClientService, this.authService, ENDPOINT,
        );
    }
}
